import { Button } from '@mui/material';
import loadable from '../Loadable';

export default loadable(Button);
